module.exports = __webpack_public_path__ + "9788f41e/img/splash-icon.07a7c465.svg";